





































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AZNCONNECT_API } from "@/services/aznconnect-api";
import { ReferralEspoedDetailsModel } from "@/types/aznconnect_api";

@Component
export default class MessageHistoryDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({ default: "" })
  referenceId!: string;

  previousMessage: ReferralEspoedDetailsModel | null = null;
  loading: boolean = false;

  @Watch("value")
  onValueChanged(value: boolean): void {
    if (value) {
      this.loadPreviousMessage();
    }
  }

  close(): void {
    this.$emit("input", false);
  }

  loadPreviousMessage(): void {
    this.previousMessage = null;
    this.loading = true;

    AZNCONNECT_API.get("/Referral/PreviousMessage", {
      params: { id: this.referenceId },
    })
      .then(response => {
        this.previousMessage = response.data as ReferralEspoedDetailsModel;
      })
      .catch(error => {
        // a 404 simply means there is no preceding message for this referral
        if (!error.response || error.response.status !== 404) {
          console.error("Failed to load the previous referral message", error);
        }
        this.previousMessage = null;
      })
      .then(() => {
        this.loading = false;
      });
  }
}
